import React from "react";
import { Button, Grid } from "antd";

const { useBreakpoint } = Grid;

const ReportTitle = ({ confirmAndRefresh, isRefreshing }) => {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: screens.xs ? "column" : "row",
        justifyContent: screens.xs ? "center" : "space-between",
        alignItems: "center",
        marginBottom: 16,
        marginTop: 16,
        gap: screens.xs ? "12px" : "0",
      }}
    >
      <span
        style={{ fontSize: screens.xs ? "12px" : "18px", fontWeight: "bold" }}
      >
        Overall Orders Success/Failure
      </span>
      <Button
        onClick={confirmAndRefresh}
        type="primary"
        loading={isRefreshing}
        style={{ width: screens.xs ? "100%" : "auto" }}
      >
        Refresh
      </Button>
    </div>
  );
};

export default ReportTitle;
